import en from './en';
import nl from './nl-be';

const { REACT_APP_DEFAULT_LANGUAGE } = process.env;
export const defaultLanguage = REACT_APP_DEFAULT_LANGUAGE || 'en';

export const messages = {
  en: en.messages,
  nl: nl.messages,
};

export const supportedLanguages = Object.keys(messages);
